import { Popover } from '@solinkcorp/solink-components';
import React from 'react';
import styles from './EventExpandPopover.module.sass';

interface EventExpandPopoverProps {
  isOpen: boolean;
  togglePopover: () => void;
  popoverButtonId: string;
  horizontalOffset?: number;
  verticalOffset?: number;
  children: React.ReactNode;
}

const EventExpandPopover: React.FC<EventExpandPopoverProps> = ({
  isOpen,
  togglePopover,
  popoverButtonId,
  verticalOffset,
  horizontalOffset,
  children,
}) => {
  return (
    <Popover
      isOpen={isOpen}
      onClose={togglePopover}
      horizontalPosition="right"
      verticalPosition="bottom"
      parent={`#${popoverButtonId}`}
      isOverlayVisible={false}
      className={styles.popover}
      horizontalOffsetToStart
      horizontalOffset={horizontalOffset}
      verticalOffset={verticalOffset}
    >
      {children}
    </Popover>
  );
};

export default EventExpandPopover;
